export default function SuperTickets() {
    return (
        <div>
            <h1 className="text-2xl font-bold">Support Tickets</h1>
            <p className="text-sm text-muted-foreground mt-1">Customer & tenant support queue</p>
            <div className="mt-6 bg-card border border-border rounded-2xl p-8 text-center text-sm text-muted-foreground">
                No open tickets. Customers can raise issues from the app \u2192 Profile \u2192 Help & Support.
            </div>
        </div>
    );
}
